import { object, string } from "yup";

export default object().shape({
  email: string().email("Invalid email address").required("Email is required"),
  name: string().required("Full name is required"),
  oldPassword: string().required("Current password is required"),
  newPassword: string(),
});
